import { RegionsGetResponse } from '@flowio/api-sdk';
import { getRegionsStatus } from '../selectors';
import ActionTypes from '../constants/ActionTypes';
import ReadyState from '../../../utilities/redux/ReadyState';
import { ThunkExtraArguments, ThunkDispatcher, RootState } from '../../../stores/types';
import { PropType } from '../../../types';
import { LegacyResponse } from '../../../utilities/clients/types/server';
import standardAction from '../../../utilities/standard-action';
import formatErrorResponseV2 from '../../../utilities/format-error-response-v2';
import toLegacyResponse from '../../../utilities/clients/to-legacy-response';

type ResponseType = PropType<RegionsGetResponse, 'body'>;

export default function fetchRegions() {
  return (
    dispatch: ThunkDispatcher,
    getState: () => RootState,
    extra: ThunkExtraArguments,
  ): Promise<LegacyResponse<ResponseType> | void> => {
    const state = getState();
    if (getRegionsStatus(state) === ReadyState.FULFILLED) {
      return Promise.resolve();
    }

    dispatch({
      type: ActionTypes.FETCH_REGIONS_REQUEST,
    });

    return extra.api(state).regionsResource.get()
      .then((response) => {
        if (response.ok) {
          dispatch(standardAction(
            ActionTypes.FETCH_REGIONS_SUCCESS,
            response.body,
          ));
        } else {
          dispatch(standardAction(
            ActionTypes.FETCH_REGIONS_FAILURE,
            formatErrorResponseV2(response),
          ));
        }
        return toLegacyResponse<ResponseType>(response);
      });
  };
}
